import React, { forwardRef } from 'react';
import { TextInput } from '../../../molecules/inputs/form/TextInput';
import { SUPPORT_CONTACT_EMAIL_MAX_CHARS, SUPPORT_COPY } from '../../../../features/AIChatWidget/constants/support';
/**
 * "Where should we reply?" — shown on the offer card ONLY when the user has no email on file
 * (`email_requires_input`). The address is used for that one ticket and never saved.
 */
export const ReplyEmailField = forwardRef(({ id, value, error, disabled = false, onChange, onSubmit }, ref) => (React.createElement(TextInput, { ref: ref, id: id, type: "email", label: SUPPORT_COPY.OFFER_EMAIL_INPUT_LABEL, value: value, error: error !== null && error !== void 0 ? error : undefined, disabled: disabled, required: true, autoComplete: "email", inputMode: "email", maxLength: SUPPORT_CONTACT_EMAIL_MAX_CHARS, "aria-invalid": Boolean(error), onChange: (event) => onChange(event.target.value), onKeyDown: (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onSubmit();
        }
    } })));
ReplyEmailField.displayName = 'ReplyEmailField';
